export const APP_ROUTES = {
  swapPage: '/swap',
  addLiquidityPage: '/liquidity',
  removeLiquidityPage: '/remove-liquidity',
  poolsPage: '/pools',
  positions: '/positions'
};
